import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'Privacy Policy' }]

const PrivacyPolicyPage = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>

		<h1 className="py-3 text-4xl font-black">
			Privacy Policy and Copyrights Statement
		</h1>
		<h2 className="py-3 text-2xl font-semibold">Authorization of Use</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The Stan Steele Agency hereby authorizes any person to access this Website
			for informational purposes only. The Stan Steele Agency reserves the right
			to terminate access to this Website at any time without notice. The data,
			information and material included in this Website is copyrighted by The
			Stan Steele Agency. All rights are reserved under the copyright laws of
			the United States of America. No part of this Website can be
			redistributed, copied or reproduced without the prior written consent of
			The Stan Steele Agency.
		</p>
		<h2 className="py-3 text-2xl font-semibold">No Warranties</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The user of this Website assumes all responsibility and risk for the use
			of this Website and the Internet generally. The Stan Steele Agency, and
			its affiliated companies disclaim all warranties, representations or
			endorsements, expressed or implied, with regard to the data, information
			and material included in, or accessible from, this Website or the
			Internet, including, but not limited to, all implied warranties of
			merchantability, fitness for a particular purpose or noninfringement. The
			Stan Steele Agency and its affiliated companies have the right to
			discontinue, change or update any data, information or material included
			in the Website without prior notice, and they do not assume any legal
			liability or responsibility for the accuracy, completeness or usefulness
			of any data, information or material included in, or accessible from, this
			Website. No advice or information given by The Stan Steele Agency or its
			affiliated companies shall create any warranty. Neither The Stan Steele
			Agency nor its affiliated companies warrants that the data, information
			and material included in the Website or on the Internet will be
			uninterruptible or error free or that any data, information, software or
			other material accessible from this Website is free of viruses or other
			harmful components. Several of our pages describe various insurance
			products. The availability of a specific product may differ from state to
			state. The product descriptions are general in nature and the insurance
			coverages are subject to the specific terms of the actual policies issued.
			If you are interested in the terms and conditions of a specific product,
			please contact us for additional information.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Disclaimer of Liability</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			In no event shall The Stan Steele Agency or its affiliated companies be
			liable for any compensatory, special, direct, incidental, indirect, or
			consequential damages, exemplary damages or any damages whatsoever
			resulting from loss of use, data, information or profits arising out of or
			in connection with the use or performance of the data, information or
			material included in this Website or on the Internet generally or on any
			other basis.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Disclaimer for Links</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Although this site includes links providing direct access to other
			Internet sites, The Stan Steele Agency and its affiliated companies take
			no responsibility for the content or information contained on those other
			sites, and does not exert any editorial or other control over those other
			sites.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Electronic Communications</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The Stan Steele Agency will not be deemed to have accepted any electronic
			communication unless The Stan Steele Agency provides the sender of the
			electronic communication with an acknowledgment verifying receipt of the
			communication. If The Stan Steele Agency sends any electronic
			communication, The Stan Steele Agency will assume the communication was
			received intact by the intended recipient. The recipient of such message
			must notify The Stan Steele Agency if the transmission was not received or
			was not received in a readable format.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Security</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Despite the security measures taken by The Stan Steele Agency, there is an
			inherent risk in disclosing personal information over the Internet. Anyone
			electronically transmitting personal information assumes the risk that
			such information may be disclosed or intercepted by unintended third
			parties and The Stan Steele Agency disclaims all liability resulting from
			such interception or disclosure. Anyone who wishes to apply for an
			insurance quote who is concerned about maintaining the security of their
			personal information may mail the information to The Stan Steele Agency.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Privacy Statement</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The Stan Steele Agency is committed to protecting your privacy as a
			visitor to this Website and as our customer. To our visitors and to our
			customers, we offer this pledge:
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The Stan Steele Agency is the owner of the information which is collected
			on this Website. We will not sell, disseminate, disclose, trade, transmit,
			transfer, share, lease or rent any personally identifiable information to
			any third party not specifically authorized by you to receive your
			information except as we have disclosed to you in this Privacy Policy.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Information Collection</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			We will ask you to provide your personal information to us when you enroll
			for coverage and when you purchase an insurance policy from us or make an
			inquiry for possible coverage which you may be interested in. We will also
			ask you to provide your personal information to us when you send e-mail to
			us from this Website or when you complete a web form requesting personal
			identifiable information. When you enroll for an insurance policy at The
			Stan Steele Agency, we will ask you to provide your name, home address,
			mailing address, telephone number, e-mail address, and other information.
			This information will be provided to the insurance company when you
			purchase an insurance policy so they can establish you as a policyholder.
			We will maintain a record of your information at the offices of The Stan
			Steele Agency, so we can provide you with policyholder service. Each
			employee has been instructed on maintaining the privacy of each customer
			and the importance of protecting the customer's personal information.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			When you purchase an insurance policy from The Stan Steele Agency, you
			will pay the premiums with your credit card or check. If you use your
			credit card to pay the premium, your credit card information is deleted
			from our records after your purchase has been authorized. We do not keep a
			record of your credit card information. If you pay the premium using your
			personal check, we may keep a copy of your check in your file.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			When you send us e-mail from this Website or complete forms on this
			Website, you will provide us with certain personally identifiable
			information including your e-mail address. We may share this information
			with third parties who provide us services in the normal course of
			business including, but not limited to, insurance carriers and their
			affiliates.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Cookies</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			We transmit non-personally identifiable information to third party service
			providers (e.g. Google) that collect website statistics. We may also
			transmit non-personally identifiable information to third party service
			providers that may use such information during your visits to this and
			other websites in order to provide advertisements about goods and services
			likely to be of greater interest to you.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			One method of collecting such information is through the use of cookies. A
			cookie is a piece of data that is stored on a visitor's hard drive while
			they are visiting this Website. We may utilize a short-lived form of
			cookie when you visit this site. At The Stan Steele Agency, a cookie is
			only used to identify one unique visitor from another visitor during a
			particular session. A session is the period of active site-use while that
			unique visitor is linked to our server.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Use of cookies helps us to improve our Website and to deliver a better and
			more personalized service by enabling us to: estimate our audience size
			and usage patterns; store information about your preferences allowing us
			to customize our Site according to your individual interests; speed up
			your searches; and recognize you when you return to our Website. You may
			refuse to accept cookies by activating the appropriate setting on your
			browser. However, if you activate such a setting, you may be unable to
			access certain parts of our Website. Unless you have adjusted your browser
			setting so that it will refuse cookies, our system will issue cookies when
			you direct your browser to our Website.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The cookie expires and is deleted from the visitor's computer as soon as
			they close their browser or if they are not actively browsing our Website
			for more than 20 minutes. Should a previous visitor to our Website return
			for a new session, they will be issued a new cookie and in no way will
			they be recognized as a visitor from a previous visit or session.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Third-Party Links</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			This Website may contain links to third-party Websites that are not
			controlled by The Stan Steele Agency. These third-party links are made
			available to you as a convenience and you agree to use these links at your
			own risk.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Please be aware that The Stan Steele Agency is not responsible for the
			content of third-party Websites linked to this website nor are we
			responsible for the privacy policy or practices of third-party Websites
			linked to this website. Our Privacy Policy only applies to information we
			collect from you while you are actively in a connection with The Stan
			Steele Agency. If you should link to a third-party Website from The Stan
			Steele Agency, we strongly encourage you to review and become familiar
			with that Website's privacy policy.
		</p>
		<h2 className="py-3 text-2xl font-semibold">
			Changes In Our Privacy Policy
		</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			We reserve the right to change this Privacy Policy without providing you
			with advance notice of our intent to make the changes. If you have any
			questions about our privacy policy, please feel free to contact us.
		</p>
		<h2 className="py-3 text-2xl font-semibold">Copyright</h2>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The Stan Steele Agency logo, and other marks, including the names of
			various products and services described within and offered by companies
			represented by The Stan Steele Agency and its subsidiaries are service
			marks of these companies.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Permission to use, copy and distribute these materials without fee is
			hereby granted, for non-commercial purposes, provided that the material is
			unaltered and The Stan Steele Agency copyright notice appears in all
			copies.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Use of this site shall be governed by and construed in accordance with the
			laws of our state of business, without giving effect to any principles of
			conflicts of laws. Any dispute concerning this site shall be subject to
			the exclusive venue of a court of competent jurisdiction in our state of
			business.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Should any provision of our terms and conditions be held invalid, unlawful
			or for any reason unenforceable, then the invalid, unlawful or
			unenforceable provision shall be severable from the remaining provisions.
			Such invalid, unlawful, or unenforceable provision shall not affect the
			validity or enforceability of the remaining provisions.
		</p>
	</main>
)

export default PrivacyPolicyPage
